import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import './index.less';
import cx from 'classnames';
import logoImg from 'assets/img/logo-new.svg';
import { LoginModalCtx } from '..';
import { useSelector } from 'react-redux';
import Store from 'redux/type';
import { Dropdown } from 'm-ui';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import { chooseAccount } from '@ad/uc';
import { getAccountId } from 'utils/login';
import { DropdownMenu } from 'component/Header/DropdownMenu';
import { animated, useSpring } from 'react-spring';
import { ArrowRight, Down } from '@icon-park/react';
import { RouterPath, KnowledgeUrl } from 'constants/constants';
import { learnLinkLog } from 'utils/businesslog';
import { ServiceMatrix } from '@ad/kcfe-service-matrix';
import { ReactComponent as Entry } from './entry.svg';

export interface NavItem {
    title: string;
    href: string;
    target?: string;
    handleClick?: Function;
}
export const NavList: NavItem[] = [
    { title: '首页', href: '/' },
    {
        title: '学习专区',
        href: KnowledgeUrl[process.env.REACT_APP_RUN_ENV],
        target: '_blank',
        handleClick: () => {
            // source 代表 1:首页 2:非首页
            // tab 代表 1:学习专区 2:最新动态
            learnLinkLog({ source: 2, tab: 1 });
        },
    },
    {
        title: '功能动态',
        href: 'https://docs.qingque.cn/d/home/eZQADUlQqKKqS4g7plWt6zOJB?identityId=1oE1vZDL4PE#section=h.hazef1fqdiny',
        target: '_blank',
    },
];

export function Header() {
    const [hasBg, setHasBg] = useState(false);
    function fixHeaderBackground() {
        setHasBg(window.scrollY > 100);
    }
    useEffect(() => {
        window.addEventListener('scroll', fixHeaderBackground);
        return () => window.removeEventListener('scroll', fixHeaderBackground);
    }, []);

    const { openLoginModal } = useContext(LoginModalCtx);

    const loginInfo = useSelector((state: Store) => state.common.loginInfo);

    const location = useLocation();

    const activeLink = location.pathname;
    const isHome = location.pathname === '/';

    const [hoverNavLink, setHoverNavLink] = useState<'/' | '/feature' | undefined>(undefined);

    const navRef = useRef<HTMLUListElement>(null);
    const [indicateInfo, setIndicateInfo] = useState({
        width: 0,
        transform: `translateX(${0}px)`,
    });
    useEffect(() => {
        const style = {
            width: 0,
            transform: `translateX(${0}px)`,
        };
        const wrapRect = navRef.current.getBoundingClientRect();
        const dom = navRef.current.querySelector(`[href='${hoverNavLink || activeLink}']`);
        const domRect = dom.getBoundingClientRect();
        style.width = domRect.width;
        style.transform = `translateX(${domRect.x - wrapRect.x}px)`;
        setIndicateInfo(style);
    }, [hoverNavLink, activeLink]);
    const indicateStyle = useSpring(indicateInfo);

    return (
        <header
            className={cx('header', {
                'header-bg': hasBg || !isHome,
            })}
        >
            <meta
                name="viewport"
                content="width=device-width, initial-scale=0.7, maximum-scale=0.7, minimum-scale=0.7, user-scalable=no"
            />
            <div className="container">
                <NavLink to="/">
                    <span className="logo">
                        <img src={logoImg} />
                    </span>
                </NavLink>
                <span className="right">
                    <ul className="nav" ref={navRef}>
                        {NavList.map((item) => {
                            return (
                                <li key={item.href}>
                                    <a
                                        href={item.href}
                                        className={cx({
                                            active: activeLink === item.href,
                                        })}
                                        target={item.target ? item.target : undefined}
                                        onClick={
                                            item?.handleClick
                                                ? () => item?.handleClick()
                                                : undefined
                                        }
                                    >
                                        {item.title}
                                    </a>
                                </li>
                            );
                        })}
                        <animated.i className="indicate" style={indicateStyle} />
                    </ul>
                    {!loginInfo.user ? (
                        <button className="login-button button--wayra" onClick={openLoginModal}>
                            登录
                        </button>
                    ) : (
                        <UserCard user={loginInfo.user} />
                    )}
                    <div className="dmp-service-matrix">
                        {/* 标识磁力万象ID */}
                        <ServiceMatrix accessId={8} entryIcon={<Entry />} />
                    </div>
                </span>
            </div>
        </header>
    );
}

export default React.memo(Header);

export function UserCard(props: {
    user: {
        user_id: number;
        user_name: string;
        headurl: string;
    };
}) {
    const { user } = props;
    const history = useHistory();

    const account = useMemo(() => getAccountId(), [user]);

    return (
        <div className="user-info">
            <a
                className="entry"
                onClick={() => {
                    account
                        ? history.push(RouterPath.FRONT_PAGE)
                        : (chooseAccount({ closeable: true }) as unknown as string);
                }}
            >
                进入系统 <ArrowRight theme="outline" size="18" fill="#97A1B8" />
            </a>
            <Dropdown
                placement="bottomRight"
                overlay={
                    <DropdownMenu
                        userId={user.user_id}
                        userName={user.user_name}
                        account={account}
                        getContainer={document.body}
                    />
                }
            >
                <span className="head">
                    <span className="headimg">
                        <img src={props.user.headurl} />
                    </span>
                    <Down theme="outline" size="18" fill="#97A1B8" />
                </span>
            </Dropdown>
        </div>
    );
}
